import React from "react";

import { fetchWithSupabaseAuth } from "../lib/supabaseClient.js";

const SESSION_PRESENCE_HEARTBEAT_MS = 120_000;

export default function useSessionPresenceHeartbeat({ enabled = false, section = "", userId = "" } = {}) {
  React.useEffect(() => {
    const resolvedUserId = typeof userId === "string" ? userId.trim() : "";
    const targetWindow = typeof window !== "undefined" ? window : null;
    const targetDocument = typeof document !== "undefined" ? document : null;
    if (!enabled || !resolvedUserId || !targetWindow) {
      return undefined;
    }

    const recordPresence = () => {
      if (targetDocument?.visibilityState === "hidden") {
        return;
      }

      void fetchWithSupabaseAuth("/api/me/session-presence", {
        body: JSON.stringify({ section: section || null }),
        headers: { "Content-Type": "application/json" },
        method: "POST",
      }).catch(() => {});
    };

    const handleVisibilityChange = () => {
      if (!targetDocument || targetDocument.visibilityState === "visible") {
        recordPresence();
      }
    };

    recordPresence();
    const heartbeatId = targetWindow.setInterval(recordPresence, SESSION_PRESENCE_HEARTBEAT_MS);
    targetDocument?.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      targetWindow.clearInterval(heartbeatId);
      targetDocument?.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [enabled, section, userId]); // Changer de section renvoie aussitôt le signal.
}
